var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"pa-2 pa-md-4 align-center justify-center d-flex flex-column"},[_c('Nuxt')],1),_vm._v(" "),(_vm.toast.show)?_c('v-snackbar',{attrs:{"value":true,"timeout":_vm.toast.timeout,"color":_vm.toast.color,"min-width":50,"bottom":""}},[_vm._v("\n    "+_vm._s(_vm.toast.message)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }